(function(window, mL, mL_errors, mL_events, mL_config) {
    "use strict";

    var key = '4cite';

    function safe_start() {
        if (mL_config.do_not_track || !mL_config.tags || !mL_config.tags.fc) return;

        window._svq = window._svq || [];

        _svq.push(['_setAccount', '1183_03587']);

        function get_cart_skus(items) {
            var skus = [],
                i = 0,
                l = items.length;

            for (i; i < l; i += 1) {
                skus.push(items[i].itemid);
            }

            return skus;
        }

        mL_events.subscribe('page', function(msg, data) {
            if (mL_config.AUDIT) console.log('pubsub ' + key + ' - ' + msg, data);
            var cart_items;

            if (msg === 'page.item') {
                _svq.push(['_setContext', "'productid':'" + data.item.sku + "'"]);

                if (mL_config.DEBUG) console.log(key + ' - ' + msg, data.item.sku);

            } else if (msg === 'page.category') {
                _svq.push(['_setContext', "'productcat':'"  + data.category.name + "'"]);

                if (mL_config.DEBUG) console.log(key + ' - ' + msg, data.category.name);

            } else if (msg === 'page.cart') {
                cart_items = get_cart_skus(data.cart.items);
                _svq.push(['_setIsCart', 'true']);
                _svq.push(['_setCartProduct', cart_items]);
                if (mL_config.DEBUG) console.log(key + ' - ' + msg, { cart_items: cart_items });
            }


            _svq.push(['_trackPageView']);           
        });

        mL_events.subscribe('form', function(msg, obj) {
            if (!obj.data || !obj.data.email) return;

            _svq.push(['_setEm', obj.data.email]);
            _svq.push(['_trackPageView']);

            if (mL_config.DEBUG) console.log(key + ' - ' + msg, obj.data.email);
        });

        mL_events.subscribe('order.pageview', function(msg, data) {
            var _url = data.url;

            _svq.push(['_trackPageView']);

            if (mL_config.DEBUG) console.log(key + ' - ' + msg + ' - data', _url);
        });

        mL_events.subscribe('order.confirmation', function(msg, data) {
            var _order = data.order;

            if (!data.is_dev) {
                _svq.push(['_setIsPurch', 'true']);
                _svq.push(['_setPurchID', _order.order_id]);
                _svq.push(['_setPurchDollar', _order.revenue]);
                _svq.push(['_setPurchProduct', _order.skus]);
                _svq.push(['_trackPageView']);
            }

            if (mL_config.DEBUG) console.log(key + ' - ' + msg);
        });

        /*
        function offerdisplay(_evt) {
            var _data = {};
            var event_map = {
                '4cite already desktop': {
                    action: '4Cite Re-Subscribe Desktop Success',
                    label: 'Re-Subscribe'
                },
                '4cite already mobile': {
                    action: '4Cite Re-Subscribe Mobile Success',
                    label: 'Re-Subscribe'
                },
                '4cite sign-up desktop': {
                    action: '4Cite Subscribe Desktop Success',
                    label: 'Subscribe'
                },
                '4cite sign-up mobile': {
                    action: '4Cite Subscribe Mobile Success',
                    label: 'Subscribe'
                }
            };

            var _key;

            if (_evt.detail) {
                if (_evt.detail.response) {
                    if (_evt.detail.response.eventAction === "success") {

                        _key = event_map[_evt.detail.response.eventSource];
                        _data.eventAction = _key.action || "success";
                        _data.eventCategory = "Email Acquisition";
                        _data.eventLabel = _key.action || 'unknown eventSource - ' + _evt.detail.response.eventSource;
                        if (_evt.detail.response.email_hash) _data.email_hash = _evt.detail.response.email_hash;
                        if (_evt.detail.response.utm_campaign) _data.utm_campaign = _evt.detail.response.utm_campaign;
                        if (_evt.detail.response.utm_medium) _data.utm_medium = _evt.detail.response.utm_medium;
                        if (_evt.detail.response.utm_source) _data.utm_source = _evt.detail.response.utm_source;
                        _data.submit = true;

                    } else if (!mL_config.popup_viewed) {
                        mL_config.popup_viewed = true;
                        _data.eventAction = "4Cite Popup View";
                        _data.eventCategory = "Email Acquisition";
                        _data.eventLabel = "View Offer";
                        _data.submit = true;
                    }

                }
            }

            if (_data.submit) {
                mL_events.publish('form.submit', { data: _data });
            }


            if (mL_config.DEBUG) console.log(key + ' - offerdisplay', _evt);
        }
        */

        mL.fc = mL.fc || {};

        mL.fc.init = function() {
            if (mL.fc.is_init || !mL.add_tracker || !_svq) return false;

            mL.add_tracker('https://track.securedvisit.com/js/sv.js', '4cite');

            mL.fc.is_init = true;

            /*
            try {
                window._svData = window._svData || []; // this is also present in the head
                window._svData.push(['on', 'offerdisplay', offerdisplay]);
            } catch (err) {
                mL_errors(err);
            }
            */

            if (mL_config.DEBUG) console.log(key + ' - plugin loaded');
        };
    }

    try {
        safe_start();
    } catch (err) {
        mL_errors(new Error('safe_start failed - ' + key.toUpperCase()));
        mL_errors(err);
    }


}(window, window.mL, window.mL_errors, window.mL_events, window.mL_config));